import { cfLogo } from "../../../assets";
import { defaultTopPicks, offerDealImage, productImage } from "../../../assets";

export function DefaultTemplateDisplay({ customizeState }) {
  return (
    <>
      <div className="flex flex-col items-center p-1 pt-3">
        <img
          className="mt-4"
          src={
            customizeState?.title?.customizeProperties?.image?.propertyValue ===
            ""
              ? cfLogo
              : customizeState?.title?.customizeProperties?.image?.propertyValue
          }
          alt="No Image Found"
          style={{
            width: "40%",
          }}
        />

        <p
          className="word-wrap text-center mt-2.5 fw-semibold"
          style={{
            color: `${customizeState?.title?.customizeProperties?.fontColor?.propertyValue}`,
            fontStyle: `${customizeState?.title?.customizeProperties?.fontStyle?.propertyValue}`,
            fontFamily: `${customizeState?.title?.customizeProperties?.fontFamily?.propertyValue}`,
            width: "70%",
          }}
        >
          {customizeState?.title?.customizeProperties?.text?.propertyValue}
        </p>

        <div className="flex gap-3.5 mt-3">
          <div className="flex flex-col w-100" style={{ maxWidth: "190px" }}>
            <img
              src={
                customizeState?.offer1?.customizeProperties?.image
                  ?.propertyValue == ""
                  ? offerDealImage
                  : customizeState?.offer1?.customizeProperties?.image
                      ?.propertyValue
              }
              style={{ height: "100%", width: "100%" }}
              alt="No Image Found"
            />
            <div
              className="p-2 text-sm"
              style={{
                background:
                  "linear-gradient(179deg, #FFE59E 0.55%, rgba(239, 218, 161, 0.00) 128.16%)",
                marginTop: "-1px",
                marginRight: "1px",
              }}
            >
              <p>
                {
                  customizeState?.offer1?.customizeProperties?.offerName
                    ?.propertyValue
                }
              </p>
              <p className="fw-bold">
                {
                  customizeState?.offer1?.customizeProperties?.offer
                    ?.propertyValue
                }
              </p>
              <p className="text-xs">
                Coupon:{" "}
                {
                  customizeState?.offer1?.customizeProperties?.couponCode
                    ?.propertyValue
                }
              </p>
            </div>
          </div>
          <div className="flex flex-col w-100" style={{ maxWidth: "190px" }}>
            <img
              src={
                customizeState?.offer2?.customizeProperties?.image
                  ?.propertyValue === ""
                  ? offerDealImage
                  : customizeState?.offer2?.customizeProperties?.image
                      ?.propertyValue
              }
              style={{ height: "100%", width: "100%" }}
              alt="No Image Found"
            />
            <div
              className="p-2 text-sm"
              style={{
                background:
                  "linear-gradient(179deg, #FFE59E 0.55%, rgba(239, 218, 161, 0.00) 128.16%)",
                marginTop: "-1px",
                marginRight: "1px",
              }}
            >
              <p>
                {
                  customizeState?.offer2?.customizeProperties?.offerName
                    ?.propertyValue
                }
              </p>
              <p className="fw-bold">
                {
                  customizeState?.offer2?.customizeProperties?.offer
                    ?.propertyValue
                }
              </p>
              <p className="text-xs">
                Coupon:{" "}
                {
                  customizeState?.offer2?.customizeProperties?.couponCode
                    ?.propertyValue
                }
              </p>
            </div>
          </div>
        </div>

        {/* Shop now button */}
        <button className="w-36 bg-[rgba(110,60,210)] text-white p-3 px-3.5 rounded-1 fw-semibold mt-3 text-xs">
          SHOP NOW
        </button>

        <img className="mt-4" src={defaultTopPicks} style={{ width: "85%" }} />

        {/* Column of products */}
        <div
          className="flex flex-col p-3 mt-2 gap-4 w-100"
          style={{ maxWidth: "560px" }}
        >
          {/* Product 1 */}
          <div className="flex justify-between">
            <div className="flex gap-3" style={{ width: "85%" }}>
              <img
                src={
                  customizeState?.product1?.customizeProperties?.image
                    ?.propertyValue === ""
                    ? productImage
                    : customizeState?.product1?.customizeProperties?.image
                        ?.propertyValue
                }
                alt="No Image"
                className="text-xs w-24 break-words"
              />
              <div className="flex flex-col gap-1.5 mt-1">
                <p className="text-lg fw-bold">
                  {
                    customizeState?.product1?.customizeProperties?.productName
                      ?.propertyValue
                  }
                </p>
                <p className="text-sm mt-0.5">
                  Qty:{" "}
                  {
                    customizeState?.product1?.customizeProperties?.quantity
                      ?.propertyValue
                  }
                  , Price: $
                  {
                    customizeState?.product1?.customizeProperties?.discountPrice
                      ?.propertyValue
                  }
                </p>
                <div className="text-xs mt-0.5 flex gap-2">
                  {
                    customizeState?.product1?.customizeProperties?.offer
                      ?.propertyValue
                  }
                  <p className="text-green-500 fw-bold">
                    {
                      customizeState?.product1?.customizeProperties?.couponCode
                        ?.propertyValue
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className="flex gap-2.5 text-lg mt-3" style={{ width: "15%" }}>
              <p className="fw-bold text-red-600 line-through text-right">
                $
                {
                  customizeState?.product1?.customizeProperties?.initialPrice
                    ?.propertyValue
                }
              </p>
              <p className="fw-bold text-right">
                $
                {
                  customizeState?.product1?.customizeProperties?.discountPrice
                    ?.propertyValue
                }
              </p>
            </div>
          </div>

          {/* Product 2 */}
          <div className="flex justify-between">
            <div className="flex gap-3" style={{ width: "85%" }}>
              <img
                src={
                  customizeState?.product2?.customizeProperties?.image
                    ?.propertyValue === ""
                    ? productImage
                    : customizeState?.product2?.customizeProperties?.image
                        ?.propertyValue
                }
                alt="No Image"
                className="text-xs w-24 break-words"
              />
              <div className="flex flex-col gap-1.5 mt-1">
                <p className="text-lg fw-bold">
                  {
                    customizeState?.product2?.customizeProperties?.productName
                      ?.propertyValue
                  }
                </p>
                <p className="text-sm mt-0.5">
                  Qty:{" "}
                  {
                    customizeState?.product2?.customizeProperties?.quantity
                      ?.propertyValue
                  }
                  , Price: $
                  {
                    customizeState?.product2?.customizeProperties?.discountPrice
                      ?.propertyValue
                  }
                </p>
                <div className="text-xs mt-0.5 flex gap-2">
                  {
                    customizeState?.product2?.customizeProperties?.offer
                      ?.propertyValue
                  }
                  <p className="text-green-500 fw-bold">
                    {
                      customizeState?.product2?.customizeProperties?.couponCode
                        ?.propertyValue
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className="flex gap-2.5 text-lg mt-3" style={{ width: "15%" }}>
              <p className="fw-bold text-red-600 line-through text-right">
                $
                {
                  customizeState?.product2?.customizeProperties?.initialPrice
                    ?.propertyValue
                }
              </p>
              <p className="fw-bold text-right">
                $
                {
                  customizeState?.product2?.customizeProperties?.discountPrice
                    ?.propertyValue
                }
              </p>
            </div>
          </div>

          {/* Product 3 */}
          <div className="flex justify-between">
            <div className="flex gap-3" style={{ width: "85%" }}>
              <img
                src={
                  customizeState?.product3?.customizeProperties?.image
                    ?.propertyValue === ""
                    ? productImage
                    : customizeState?.product3?.customizeProperties?.image
                        ?.propertyValue
                }
                alt="No Image"
                className="text-xs w-24 break-words"
              />
              <div className="flex flex-col gap-1.5 mt-1">
                <p className="text-lg fw-bold">
                  {
                    customizeState?.product3?.customizeProperties?.productName
                      ?.propertyValue
                  }
                </p>
                <p className="text-sm mt-0.5">
                  Qty:{" "}
                  {
                    customizeState?.product3?.customizeProperties?.quantity
                      ?.propertyValue
                  }
                  , Price: $
                  {
                    customizeState?.product3?.customizeProperties?.discountPrice
                      ?.propertyValue
                  }
                </p>
                <div className="text-xs mt-0.5 flex gap-2">
                  {
                    customizeState?.product3?.customizeProperties?.offer
                      ?.propertyValue
                  }
                  <p className="text-green-500 fw-bold">
                    {
                      customizeState?.product3?.customizeProperties?.couponCode
                        ?.propertyValue
                    }
                  </p>
                </div>
              </div>
            </div>
            <div className="flex gap-2.5 text-lg mt-3" style={{ width: "15%" }}>
              <p className="fw-bold text-red-600 line-through text-right">
                $
                {
                  customizeState?.product3?.customizeProperties?.initialPrice
                    ?.propertyValue
                }
              </p>
              <p className="fw-bold text-right">
                $
                {
                  customizeState?.product3?.customizeProperties?.discountPrice
                    ?.propertyValue
                }
              </p>
            </div>
          </div>
        </div>

        {/* Checkout cart and discount code messages */}
        <button className="w-60 bg-[rgba(110,60,210)] text-white p-3 px-3 rounded-1 fw-semibold mt-3 text-xs">
          CHECKOUT YOUR CART
        </button>

        <p className="fw-semibold text-xl mt-3">
          Don't forget to use your code!
        </p>

        <div
          className="mt-2.5 p-2 px-3 fw-bold border-dashed border-1 text-center"
          style={{
            fontSize: "37px",
            color: `${customizeState?.discountCode?.customizeProperties?.textColor?.propertyValue}`,
            fontStyle: `${customizeState?.discountCode?.customizeProperties?.fontStyle?.propertyValue}`,
            fontFamily: `${customizeState?.discountCode?.customizeProperties?.fontFamily?.propertyValue}`,
            borderColor: `${customizeState?.discountCode?.customizeProperties?.borderColor?.propertyValue}`,
          }}
        >
          {
            customizeState?.discountCode?.customizeProperties?.text
              ?.propertyValue
          }
        </div>
      </div>

      {/* Footer */}
      <div
        className="flex flex-col justify-center items-center mt-5 pt-2 gap-4"
        style={{
          width: "100%",
          backgroundColor: `${customizeState?.footer?.customizeProperties?.backgroundColor?.propertyValue}`,
        }}
      >
        <img
          src={
            customizeState?.title?.customizeProperties?.image?.propertyValue ===
            ""
              ? cfLogo
              : customizeState?.title?.customizeProperties?.image?.propertyValue
          }
          alt="No Image Found"
          className="mt-5"
          style={{ width: "40%" }}
        />
        <div className="fw-semibold text-sm mb-5">
          &copy;{" "}
          {
            customizeState?.footer?.customizeProperties?.copyRight
              ?.propertyValue
          }
        </div>
      </div>
    </>
  );
}
